import {BsCurrencyDollar, BsShield} from "react-icons/bs";
import {FiCalendar, FiCreditCard} from "react-icons/fi";
import React from "react";
import {TiTick} from "react-icons/ti";

// mock data removed (unused) to satisfy linter

export const weeklyStats = [
  {
    icon: React.createElement(FiCalendar as any),
    amount: '-$560',
    title: 'Top Sales',
    desc: 'Johnathan Doe',
    iconBg: '#FB9678',
    pcColor: 'red-600',
  },
  {
    icon: React.createElement(FiCalendar as any),
    amount: '-$560',
    title: 'Best Seller',
    desc: 'MaterialPro Admin',
    iconBg: 'rgb(254, 201, 15)',
    pcColor: 'red-600',
  },
  {
    icon: React.createElement(FiCalendar as any),
    amount: '+$560',
    title: 'Most Commented',
    desc: 'Ample Admin',
    iconBg: '#00C292',
    pcColor: 'green-600',
  },
];

export const dropdownData = [
  {
    Id: '1',
    Time: 'March 2021',
  },
  {
    Id: '2',
    Time: 'April 2021',
  }, {
    Id: '3',
    Time: 'May 2021',
  },
];

export const SparklineAreaData = [
  {x: 1, yval: 2},
  {x: 2, yval: 6},
  {x: 3, yval: 8},
  {x: 4, yval: 5},
  {x: 5, yval: 10},
];


//todo: analysis if needed
export const medicalproBranding = {
  data: [
    {
      title: 'Due Date',
      desc: 'Oct 23, 2021',
    },
    {
      title: 'Budget',
      desc: '$98,500',
    },
    {
      title: 'Expense',
      desc: '$63,000',
    },
  ],
  teams: [
    {
      name: 'Bootstrap',
      color: 'orange',
    },
    {
      name: 'Angular',
      color: '#FB9678',
    },
  ],
};
export const recentTransactions = [
  {
    icon: React.createElement(BsCurrencyDollar as any),
    amount: '+$350',
    title: 'Paypal Transfer',
    desc: 'Money Added',
    iconColor: '#03C9D7',
    iconBg: '#E5FAFB',
    pcColor: 'green-600',
  },
  {
    icon: React.createElement(BsShield as any),
    amount: '-$560',
    desc: 'Bill Payment',
    title: 'Wallet',
    iconColor: 'rgb(0, 194, 146)',
    iconBg: 'rgb(235, 250, 242)',
    pcColor: 'red-600',
  },
  {
    icon: React.createElement(FiCreditCard as any),
    amount: '+$350',
    title: 'Credit Card',
    desc: 'Money reversed',
    iconColor: 'rgb(255, 244, 229)',
    iconBg: 'rgb(254, 201, 15)',

    pcColor: 'green-600',
  },
  {
    icon: React.createElement(TiTick as any),
    amount: '+$350',
    title: 'Bank Transfer',
    desc: 'Money Added',

    iconColor: 'rgb(228, 106, 118)',
    iconBg: 'rgb(255, 244, 229)',
    pcColor: 'green-600',
  },
  {
    icon: React.createElement(BsCurrencyDollar as any),
    amount: '-$50',
    percentage: '+38%',
    title: 'Refund',
    desc: 'Payment Sent',
    iconColor: '#03C9D7',
    iconBg: '#E5FAFB',
    pcColor: 'red-600',
  },
];

export const ecomPieChartData = [
  {x: '2018', y: 18, text: '35%'},
  {x: '2019', y: 18, text: '15%'},
  {x: '2020', y: 18, text: '25%'},
  {x: '2021', y: 18, text: '25%'},
];
